import { useInViewport } from '@/hooks/useInViewport';

import { ConnectionButton } from './connection-button';

import type { WikiPerson } from '../people-wiki.types';

/** The button of a person in the wiki list. Each address looked up counts against a daily limit, so a row looks up
 * its addresses only once it is near the screen. A click on the button or its menu does not open the person's page,
 * and a click on the empty space of the cell still does. */
export const RowConnectionButton = ({ person }: { person: WikiPerson }) => {
  const { ref, inViewport } = useInViewport<HTMLDivElement>({
    rootMargin: '200px',
  });

  return (
    <div ref={ref} className="min-h-8">
      {inViewport && (
        // The menu of the button is a child of this element in React's tree, so its clicks stop here as well
        <div className="w-fit" onClick={(event) => event.stopPropagation()}>
          <ConnectionButton person={person} surface="wiki_list" />
        </div>
      )}
    </div>
  );
};
